import { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { tr } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { Calendar } from "../ui/calendar";

/** Turkish date picker. value/onChange use "YYYY-MM-DD" strings (same as native date input). */
export default function DatePicker({ value, onChange, placeholder = "Tarih seç", testid, clearable = false, className = "" }) {
  const [open, setOpen] = useState(false);
  const d = value ? parseISO(String(value).slice(0, 10)) : null;
  const selected = d && isValid(d) ? d : undefined;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`flex h-9 w-full items-center gap-2 rounded-md border border-input bg-transparent px-3 text-sm shadow-sm text-left hover:bg-slate-50 focus:outline-none focus:ring-1 focus:ring-ring ${className}`}>
          <CalendarDays size={15} className="text-slate-500 shrink-0" />
          <span className={`flex-1 truncate ${selected ? "text-slate-900" : "text-slate-400"}`}>
            {selected ? format(selected, "d MMMM yyyy", { locale: tr }) : placeholder}
          </span>
          {clearable && selected && (
            <X size={14} className="text-slate-400 hover:text-slate-700" data-testid={testid ? `${testid}-clear` : undefined}
              onClick={(e) => { e.stopPropagation(); onChange(""); }} />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={tr} weekStartsOn={1} selected={selected} defaultMonth={selected}
          onSelect={(day) => { if (day) { onChange(format(day, "yyyy-MM-dd")); setOpen(false); } }}
          initialFocus />
      </PopoverContent>
    </Popover>
  );
}
